import ReactDOM from 'react-dom';
// eslint-disable-next-line no-unused-vars,import/no-unresolved
import React from 'react';
import ProductsComponent from './components/ProductsComponent';

jQuery( document ).ready( function() {
	const elements = document.querySelectorAll( '.js-qec-wc-products' );

	if ( elements.length === 0 ) {
		return;
	}

	elements.forEach( element => {
		ReactDOM.render(
			<ProductsComponent attributes={ JSON.parse( element.dataset.attributes ) } config={ JSON.parse( element.dataset.config ) } />,
			element
		);
	} );
} );
